import React, { useEffect, useState } from "react";
import TopHeader from "../Dashoboard/TopHeader";
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { saveLoader } from "../../redux/slice/loaderNoti";
import OwnerDetails from "./OwnerDetails";
import {
  useLazyOwnerListQuery,
  useLazyOwnerTransactionsListQuery,
  useLazyPropertiesOwnerListQuery,
} from "../../redux/api/api";
import FinancialDetails from "./FinancialDetails";
import moment from "moment/moment";
import Property from "./Property";

const PropertiesOwnerView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [btn, setBtn] = useState(false);
  const [tab, setTab] = useState(1);

  const [details, setDetails] = useState({});
  const [transactionPage, setTransactionPage] = useState(1);
  const [transactionCount, setTransactionCount] = useState(1);
  const [pagonationTransaction, setPagonationTransaction] = useState({});
  const [transactionRow, setTransactionRow] = useState(10);
  const [transactionFrom_date, setTransactionFrom_date] = useState("");
  const [transactionTo_date, setTransactionTo_date] = useState("");
  const [transactionList, setTransactionList] = useState([]);

  const [listProperty, setListProperty] = useState([]);
  const [rowProperty, setRowProperty] = useState(10);
  const [propertyPage, setPropertyPage] = useState(1);
  const [paginationProperty, setPaginationProperty] = useState({});
  const [propertyCount, setPropertyCount] = useState(1);

  // RTK QUERY
  const [ownerListApi] = useLazyOwnerListQuery();
  const [ownerTransactionsListApi] = useLazyOwnerTransactionsListQuery();
  const [propertiesOwnerApi] = useLazyPropertiesOwnerListQuery();

  const getDetatils = () => {
    dispatch(saveLoader(true));
    ownerListApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setDetails(res);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  const getTransactions = (row_value, from_date_value, to_date_value) => {
    let params = `${location?.state?.data?.id}?page=${transactionPage}`;

    if (row_value) {
      params += `&row=${row_value}`;
    }

    if (from_date_value) {
      params += `&from_date=${moment(from_date_value).format("YYYY-MM-DD")}`;
    }

    if (to_date_value) {
      params += `&to_date=${moment(to_date_value).format("YYYY-MM-DD")}`;
    }

    setTransactionRow(row_value);
    setTransactionFrom_date(from_date_value);
    setTransactionTo_date(to_date_value);
    dispatch(saveLoader(true));
    ownerTransactionsListApi(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setTransactionList(res?.owner_transaction_reports);
        setTransactionCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonationTransaction(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getDetatils();
    }
  }, []);

  useEffect(() => {
    if (location?.state?.data?.id) {
      getTransactions(transactionRow, transactionFrom_date, transactionTo_date);
    }
  }, [transactionPage]);

  const getProperty = (row_value) => {
    let params = `${location?.state?.data?.id}?page=${propertyPage}`;

    if (row_value) {
      params += `&row=${row_value}`;
    }

    setRowProperty(row_value);
    dispatch(saveLoader(true));
    propertiesOwnerApi(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setListProperty(res?.properties);
        setPropertyCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPaginationProperty(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getProperty(rowProperty);
    }
  }, [propertyPage]);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"properties-owner-view"} />
      <div className=" block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-12">
              <div className="nav-user">
                <div className="presentation">
                  <button
                    className={`nav-presentation  ${
                      tab == 1 ? "pre-active" : ""
                    }`}
                    onClick={() => setTab(1)}
                  >
                    Basic Details
                  </button>
                </div>
                <div className="presentation">
                  <button
                    className={`nav-presentation  ${
                      tab == 2 ? "pre-active" : ""
                    }`}
                    onClick={() => setTab(2)}
                  >
                    Property
                  </button>
                </div>
                <div className="presentation">
                  <button
                    className={`nav-presentation  ${
                      tab == 3 ? "pre-active" : ""
                    }`}
                    onClick={() => setTab(3)}
                  >
                    Financial Details
                  </button>
                </div>
              </div>
            </div>
          </Row>
          <div className="mt-5">
            {tab == 1 && <OwnerDetails details={details} />}
            {tab == 2 && (
              <Property
                details={details}
                listProperty={listProperty}
                paginationProperty={paginationProperty}
                rowProperty={rowProperty}
                setPropertyPage={setPropertyPage}
                propertyCount={propertyCount}
                getProperty={getProperty}
              />
            )}
            {tab == 3 && (
              <FinancialDetails
                details={details}
                setTransactionPage={setTransactionPage}
                transactionList={transactionList}
                getTransactions={getTransactions}
                transactionRow={transactionRow}
                transactionFrom_date={transactionFrom_date}
                transactionTo_date={transactionTo_date}
                transactionCount={transactionCount}
                pagonationTransaction={pagonationTransaction}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertiesOwnerView;
